import { createStore, applyMiddleware, compose } from "redux"
import reducers from './reducers'
import thunk from 'redux-thunk'

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
export const store = (initialState) => {
  return createStore(
    reducers, 
    initialState,
    composeEnhancers(
      applyMiddleware(
        thunk
      )
    )
  )
}